import {
    SHOW_MODAL_FORM,
    HIDE_MODAL_FORM,
} from '../actions/types';

const initialState = {
    showLoginForm: false,
    showRegisterForm: false,
    showOrderForm: false,
    exchangeRate: '',
    items: [],
    item: {}
};

function coreReducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_MODAL_FORM:
            return {
                ...state,
                [action.form]: action.payload
            };
        case HIDE_MODAL_FORM:
            return {
                ...state,
                [action.form]: action.payload
            };
        default:
            return state;
    }
};

export default coreReducer;
